import React from 'react'

export function Box({
  children,
  padding = false,
  className = '',
  disabled = false,
}: React.PropsWithChildren<{
  className?: string
  padding?: boolean
  disabled?: boolean
}>) {
  return (
    <div
      className={`bg-white shadow overflow-hidden sm:rounded-lg mx-4 ${className} ${
        disabled ? 'disabled:opacity-50' : ''
      }`}
    >
      <div className={padding ? 'px-4 py-5 sm:px-6' : ''}>{children}</div>
    </div>
  )
}
